import { Component, Input } from '@angular/core';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { TeamNavigationService } from '../../services/team-navigation.service';
import { Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { PerformanceTeamMemberOverview } from 'app/library/performance-team-review/models/performance-team-member-overview.model';
import { PerformancePersonalReviewStatusEnum } from 'app/library/performance-personal-review/enums/performance-personal-review-status.enum';

@Component({
    selector: 'app-performance-team-member-review',
    templateUrl: './performance-team-member-review.component.html',
    styleUrls: ['./performance-team-member-review.component.scss'],
})
export class PerformanceTeamMemberReviewComponent extends UnsubscribeOnDestroy {
    @Input()
    teamId: string;

    @Input()
    memberId: string;

    @Input()
    performanceTeamMemberOverviews: PerformanceTeamMemberOverview[];

    filteredPerformanceTeamMemberOverviews: PerformanceTeamMemberOverview[];

    constructor(private _store: Store, private _teamNavigationService: TeamNavigationService) {
        super();
    }

    openPerformanceTeamMemberReviewPage(): void {
        this._teamNavigationService.addTeamPath(window.location.pathname);
        this._store.dispatch(new Navigate([`/my-teams/team/${this.teamId}/member/${this.memberId}/personal-reviews`]));
    }

    ngOnInit(): void {
        this.filterStates();
    }

    private filterStates(): void {
        // Extract the relevant states
        const importantStates: PerformancePersonalReviewStatusEnum[] = [
            PerformancePersonalReviewStatusEnum.INPUT,
            PerformancePersonalReviewStatusEnum.DISCUSSION,
            PerformancePersonalReviewStatusEnum.REVIEW,
        ];

        // Create a map of statuses and counts for easy lookup
        const stateMap = new Map<PerformancePersonalReviewStatusEnum, number>();
        this.performanceTeamMemberOverviews.forEach((overview) => {
            const statusEnum = overview.status as PerformancePersonalReviewStatusEnum; // Cast status to the enum type
            stateMap.set(statusEnum, overview.count);
        });

        // Add the important states with non-zero counts
        let selectedStates = importantStates
            .filter((status) => stateMap.get(status) && stateMap.get(status)! > 0) // Only keep states with non-zero counts
            .slice(0, 3); // Limit to max 3 states

        // If none of the important states have values, show Completed regardless of count
        if (selectedStates.length === 0) {
            selectedStates = [PerformancePersonalReviewStatusEnum.COMPLETED];
        }

        // If any important state is missing, fill in with COMPLETED
        if (selectedStates.length < 3 && stateMap.get(PerformancePersonalReviewStatusEnum.COMPLETED) !== undefined) {
            selectedStates.push(PerformancePersonalReviewStatusEnum.COMPLETED);
        }

        // Ensure max of 3 states
        selectedStates = selectedStates.slice(0, 3);

        // Assign the filtered overviews based on the selected states, excluding CANCELED
        this.filteredPerformanceTeamMemberOverviews = this.performanceTeamMemberOverviews.filter(
            (overview) =>
                selectedStates.includes(overview.status as PerformancePersonalReviewStatusEnum) && // Match selected states
                overview.status !== PerformancePersonalReviewStatusEnum.CANCELED // Explicitly exclude CANCELED
        );
    }
}
